export const SITE = {
  name: "CCS Gebäudemanagement",
  tagline: "Wir schaffen Räume",
  url: "https://ccs-gm.de",
  email: "info@ccs-muelheim.de",
  phoneDisplay: "0163 40 59 271",
  phoneTel: "+491634059271",
  whatsappHref: "https://wa.me/491634059271",
  owner: "Ismail Cana",
  geo: { lat: 51.427707, lng: 6.883749 },
  addresses: [
    {
      label: "Geschäftsführung",
      street: "Kölner Straße 383C",
      zip: "45481",
      city: "Mülheim an der Ruhr",
    },
    {
      label: "Geschäftsstelle",
      street: "Althofstraße 40",
      zip: "45468",
      city: "Mülheim an der Ruhr",
    },
  ],
  area: [
    "Mülheim an der Ruhr",
    "Essen",
    "Oberhausen",
    "Duisburg",
    "Bottrop",
    "Bochum",
    "Ratingen",
    "Düsseldorf",
  ],
  legal: {
    court: "Amtsgericht Mülheim a.d. Ruhr",
    hrb: "HRB 1526545",
    vat: "DE2955555555",
  },
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2489.5080473527837!2d6.883748677066319!3d51.42770747179522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8c16de1f5bbf3%3A0xa574028a28b9831b!2sCCS%20Geb%C3%A4udemanagement!5e0!3m2!1sde!2sde!4v1748378002659!5m2!1sde!2sde",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Althofstra%C3%9Fe%2040%2C%2045468%20M%C3%BClheim%20an%20der%20Ruhr",
};

export const NAV = [
  { to: "/", label: "Start" },
  { to: "/#leistungen", label: "Leistungen" },
  { to: "/reinigung", label: "Reinigung" },
  { to: "/kontakt", label: "Kontakt" },
];

export const COMPARE_WIDE = true;

export const HERO_SLIDES = [
  {
    src: "/images/opt/start-image-1.webp",
    fallback: "/images/start-image-1.jpg",
    alt: "Fachkraft beim Innenabbruch mit Schutzausrüstung",
    caption: "Innenabbruch · Schutz · Entsorgung",
  },
  {
    src: "/images/opt/start-image-5.webp",
    fallback: "/images/start-image-5.jpg",
    alt: "Entrümpelung und Demontage in einer Wohnung",
    caption: "Entrümpelung · Demontage",
  },
  {
    src: "/images/opt/start-image-3.webp",
    fallback: "/images/start-image-3.jpg",
    alt: "Renovierung: vom Rohzustand zum fertigen Wohnraum",
    caption: "Renovierung · Farbe · Boden",
  },
  {
    src: "/images/opt/start-image-4.webp",
    fallback: "/images/start-image-4.jpg",
    alt: "Trockenbau: neue Wände und Decken im Rohbau",
    caption: "Trockenbau · neue Grundrisse",
  },
];

const compressed = (slug, side) =>
  `/images/gen/compressed/${slug}-${side}_compressed.jpg`;

const comparePair = (slug) => ({
  before: {
    fallback: compressed(slug, "before"),
  },
  after: {
    fallback: compressed(slug, "after"),
  },
});

export const SERVICES = [
  {
    slug: "abbruch",
    number: "01",
    title: "Abbrucharbeiten",
    short: "Wände, Einbauten, Hindernisse – präzise, sicher, sauber entfernt.",
    navLabel: "Abbruch",
    ...comparePair("abbruch"),
    image: compressed("abbruch", "after"),
    imageFallback: compressed("abbruch", "after"),
    hero: "/images/opt/start-image-1.webp",
    heroFallback: "/images/start-image-1.jpg",
    compare: true,
    mailSubject: "Anfrage Abbrucharbeiten",
    description:
      "Abbrucharbeiten in Mülheim, Essen und Umgebung: fachgerechte Demontage von Wänden, Bauelementen und Raumstrukturen – sicher, sauber und termingerecht.",
    lead: "Wenn eine Wand zwischen Ihnen und dem Grundriss steht, den Sie wirklich wollen.",
    body: "Planen Sie einen Umbau, aber eine Wand oder andere Hindernisse stehen im Weg? Unser Team kümmert sich um die fachgerechte Demontage von Bauelementen, Möbeln und Raumstrukturen. Ob einzelne Wand oder komplette Entkernung: wir arbeiten präzise, mit Schutz der angrenzenden Flächen, und hinterlassen eine Baustelle, auf der es weitergehen kann.",
    points: [
      "Selektiver Innenabbruch und Wanddurchbrüche",
      "Schutz von Böden, Nachbarwohnungen und Installationen",
      "Abfuhr und umweltgerechte Entsorgung",
      "Abstimmung mit Folgegewerken",
    ],
  },
  {
    slug: "demontage",
    number: "02",
    title: "Demontage & Entrümpelung",
    short: "Wohnungen, Keller, Gewerbe: wir schaffen Platz, Sie atmen durch.",
    navLabel: "Entrümpelung",
    ...comparePair("demontage"),
    image: compressed("demontage", "after"),
    imageFallback: compressed("demontage", "after"),
    hero: "/images/opt/start-image-5.webp",
    heroFallback: "/images/start-image-5.jpg",
    compare: true,
    mailSubject: "Anfrage für Demontage, Entkernung u. Entrümpelung",
    description:
      "Entrümpelung, Haushaltsauflösung und Entkernung in Mülheim und Essen – umweltgerecht, vollständig, mit Festpreis.",
    lead: "Wieder Raum zum Leben – ohne dass Sie selbst schleppen, sortieren oder entsorgen müssen.",
    body: "Ist Wohnung, Keller oder Dachboden überfüllt? Wir übernehmen die professionelle Entrümpelung von Wohnungen, Häusern und Gewerberäumen. Von alten Möbeln über Haushaltsgegenstände bis zum Sperrmüll: wir demontieren, räumen und entsorgen umweltgerecht – inklusive Haushaltsauflösungen und Entkernungen vor dem Ausbau.",
    points: [
      "Haushaltsauflösungen und Wohnungsräumung",
      "Keller, Dachboden, Garage, Gewerbe",
      "Demontage von Küchen, Einbauten und Böden",
      "Nachhaltige Entsorgung und Besenrein-Übergabe",
    ],
  },
  {
    slug: "renovierung",
    number: "03",
    title: "Renovierungsarbeiten",
    short: "Farbe, Boden, Details – Räume, die sich nach Ihnen anfühlen.",
    navLabel: "Renovierung",
    ...comparePair("renovierung"),
    image: compressed("renovierung", "after"),
    imageFallback: compressed("renovierung", "after"),
    hero: "/images/opt/start-image-3.webp",
    heroFallback: "/images/start-image-3.jpg",
    compare: true,
    mailSubject: "Anfrage Renovierungsarbeiten",
    description:
      "Renovierung und Wohnraumsanierung in Mülheim an der Ruhr: Malerarbeiten, Bodenbeläge und komplette Auffrischung aus einer Hand.",
    lead: "Kein Showroom-Look von der Stange. Räume, die zu Ihrem Alltag passen.",
    body: "Ob komplette Wohnraumsanierung oder gezielte Auffrischung: wir setzen Farbkonzept, Bodenbeläge und Details mit handwerklicher Präzision um. Unser Team bringt Struktur in die Baustelle und übergibt Räume, in denen Sie sofort weiterleben können.",
    points: [
      "Maler- und Spachtelarbeiten",
      "Bodenbeläge und Sockelleisten",
      "Komplettsanierung einzelner Zimmer",
      "Abstimmung von Material und Zeitplan mit Ihnen",
    ],
  },
  {
    slug: "trockenbau",
    number: "04",
    title: "Trockenbauarbeiten",
    short: "Neue Grundrisse, Decken, Akustik – schnell und sauber gebaut.",
    navLabel: "Trockenbau",
    ...comparePair("trockenbau"),
    image: compressed("trockenbau", "after"),
    imageFallback: compressed("trockenbau", "after"),
    hero: "/images/opt/start-image-4.webp",
    heroFallback: "/images/start-image-4.jpg",
    compare: true,
    mailSubject: "Anfrage Trockenbauarbeiten",
    description:
      "Trockenbau in Mülheim und Essen: Trennwände, abgehängte Decken, indirekte Beleuchtung und Raumaufteilung.",
    lead: "Grundrisse lassen sich neu denken, ohne das Haus abzureißen.",
    body: "Mit Trockenbau gestalten wir Räume flexibel: neue Aufteilungen, abgehängte Decken, Nischen, Akustik und indirekte Beleuchtung. Wir beraten zu Aufbau und Brandschutzanforderungen und führen von der ersten Skizze bis zur spachtelfertigen Fläche aus.",
    points: [
      "Nichttragende Trennwände und Vorsatzschalen",
      "Decken, Beleuchtungsschlitze, Dachschrägen",
      "Feuchtraumplatten und Schallschutz",
      "Anschlussfertig für Maler und Fliesenleger",
    ],
  },
  {
    slug: "fliesen",
    number: "05",
    title: "Fliesenarbeiten",
    short: "Bad, Küche, Boden: großformatig, präzise, langlebig verlegt.",
    navLabel: "Fliesen",
    ...comparePair("fliesen"),
    image: compressed("fliesen", "after"),
    imageFallback: compressed("fliesen", "after"),
    hero: compressed("fliesen", "after"),
    heroFallback: compressed("fliesen", "after"),
    compare: true,
    mailSubject: "Anfrage Fliesenarbeiten",
    description:
      "Fliesenleger in Mülheim an der Ruhr: großformatige Fliesen, Bäder, Küchen und Böden – saubere Fugen, langlebige Ausführung.",
    lead: "Flächen, die ruhig wirken – weil Maß, Fuge und Gefälle stimmen.",
    body: "Ob großformatige Fliesen im Bad oder ein neuer Boden im ganzen Geschoss: wir verlegen mit passendem Untergrund, sauberem Schnitt und gleichmäßiger Fuge. Hochwertige Materialien und eine Verarbeitung, die auch in fünf Jahren noch eben und dicht ist.",
    points: [
      "Großformat, Mosaik, Feinsteinzeug",
      "Bäder, Duschen, Küchen, Böden",
      "Abdichtung und Gefälle im Nassbereich",
      "Demontage alter Beläge auf Wunsch",
    ],
  },
  {
    slug: "umzug",
    number: "06",
    title: "Umzug & Kleintransporte",
    short: "Möbel, Geräte, IKEA-Abholung – Transporter mit Fahrer, nah und fern.",
    navLabel: "Umzug",
    ...comparePair("umzug"),
    image: compressed("umzug", "after"),
    imageFallback: compressed("umzug", "after"),
    hero: compressed("umzug", "after"),
    heroFallback: compressed("umzug", "after"),
    compare: true,
    mailSubject: "Anfrage Umzug & Kleintransport",
    description:
      "Umzug und Kleintransporte in Mülheim an der Ruhr: Möbeltransport, Abholung und Lieferung mit Transporter und Fahrer – auch kurzfristig, nah und fern.",
    lead: "Umzug, Möbeltransport oder Abholung: zuverlässig, flexibel, mit Transporter und Fahrer.",
    body: "Wir übernehmen Umzüge und Kleintransporte in Mülheim an der Ruhr und Umgebung – vom einzelnen Sofa bis zur kompletten Wohnung. Transporter mit Fahrer, Abholung im Möbelhaus, Lieferung nach Hause: Sie sagen Abhol- und Zielort, wir kümmern uns um den Rest. Kurzfristige Termine nach Absprache, Nah- und Ferntransporte.",
    points: [
      "Umzüge und Umzugshilfe",
      "Möbeltransporte und Kleintransporte",
      "Möbelabholung und Lieferung, auch aus Möbelhäusern",
      "Transporter mit Fahrer",
      "Sofa, Schrank, Bett und andere Möbel",
      "Waschmaschine, Trockner und Haushaltsgeräte",
      "IKEA-Abholungen und Lieferungen",
      "Kurzfristige Transporte nach Absprache",
      "Nah- und Ferntransporte",
      "Entrümpelungen",
    ],
    sections: [
      {
        title: "Einsatzgebiet",
        text: "Mülheim an der Ruhr und Umgebung. Auf Anfrage auch Essen, Duisburg, Oberhausen, Bottrop, Bochum, Ratingen, Düsseldorf und weitere Orte.",
      },
      {
        title: "Faire, transparente Preise",
        text: "Der Preis richtet sich nach Entfernung, Menge und Größe der Möbel, Etagen und Treppen, benötigter Arbeitszeit, Anzahl der Helfer und Wunschtermin.",
      },
      {
        title: "Für ein Angebot brauchen wir",
        items: [
          "Abholort und Zielort",
          "Was soll transportiert werden?",
          "Etage / Aufzug vorhanden?",
          "Wunschtermin",
          "Wenn möglich, Fotos der Möbel",
        ],
      },
    ],
  },
];

export function contactPath(leistung = "") {
  if (!leistung) return "/kontakt";
  return `/kontakt?leistung=${encodeURIComponent(leistung)}`;
}

export function serviceLabelFromQuery(value) {
  if (!value) return "";
  const key = String(value).trim().toLowerCase();
  if (key === "reinigung" || key === "cleaning") return "Reinigung";
  if (key === "sonstiges") return "Sonstiges";
  const match = SERVICES.find(
    (s) => s.slug === key || s.title.toLowerCase() === key
  );
  return match ? match.title : "";
}

export const CLEANING = {
  slug: "reinigung",
  number: "07",
  title: "Reinigung",
  short: "Büro, Treppe, Fenster, Brandschaden – zuverlässig und zum Festpreis.",
  description:
    "Gebäudereinigung in Mülheim und Essen: Unterhaltsreinigung, Fenster, Treppenhaus und Brandschadenreinigung durch Fachpersonal.",
  lead:
    "Büro, Gewerbe, Treppenhaus, Fenster oder Brandschaden: Fachpersonal, Festpreis, auch kurzfristig – in Mülheim, Essen und Umgebung.",
  points: [
    "Auch kurzfristig verfügbar",
    "Desinfizierende Beseitigung von Bakterien und Keimen",
    "Maßgeschneiderte Konzepte",
    "Einsatz von Fachpersonal",
    "Umweltfreundliche Reinigungsmittel",
    "Festpreisgarantie",
  ],
  heroSlides: [
    {
      src: "/images/opt/cleaning-service-1.webp",
      fallback: "/images/cleaning-service-1.jpg",
      alt: "Team bei der Gewerbereinigung in einem Büro",
      caption: "Gewerbe — Unterhalt",
    },
    {
      src: "/images/opt/cleaning-service-4.webp",
      fallback: "/images/cleaning-service-4.jpg",
      alt: "Professionelle Gebäudereinigung vor Ort",
      caption: "Objekt — Feinreinigung",
    },
  ],
  qualities: [
    {
      n: "01",
      title: "Festpreisgarantie",
      text: "Faire, transparente Preise. Keine versteckten Kosten.",
    },
    {
      n: "02",
      title: "Erfahrung",
      text: "Kompetent, gründlich, zuverlässig – seit vielen Jahren vor Ort.",
    },
    {
      n: "03",
      title: "Keine Wartezeit",
      text: "Kleine Struktur, kurze Wege, auch kurzfristige Termine.",
    },
  ],
  benefits: [
    {
      title: "Hygiene",
      text: "Saubere Flächen, weniger Keime – spürbar im Alltag des Objekts.",
    },
    {
      title: "Erscheinungsbild",
      text: "Räume, die nach gepflegt aussehen, nicht nach Aufwand.",
    },
    {
      title: "Gesundheit",
      text: "Weniger Krankheitsausfälle, weil Staub und Keime nicht bleiben.",
    },
    {
      title: "Motivation",
      text: "Ein aufgeräumtes Umfeld, in dem sich Arbeit leichter anfühlt.",
    },
    {
      title: "Fokus",
      text: "Sie kümmern sich ums Geschäft. Wir um den Rest.",
    },
  ],
  services: [
    {
      id: "gewerbe",
      kicker: "Unterhalt",
      title: "Gewerbereinigung",
      text: "Einzelhandel, öffentliche Gebäude, Gastronomie, Hotels, Praxen und Büros. Wir halten Flächen repräsentativ und hygienisch – in dem Rhythmus, den Ihr Betrieb braucht.",
      image: "/images/opt/cleaning-service-1.webp",
      imageFallback: "/images/cleaning-service-1.jpg",
      mailSubject: "Anfrage für Gewerbereinigung",
    },
    {
      id: "fenster",
      kicker: "Glas",
      title: "Fensterreinigung",
      text: "Streifenfreie Glasflächen innen und außen. Mit schonenden, umweltfreundlichen Mitteln – für klare Sicht und ein gepflegtes Erscheinungsbild.",
      image: "/images/opt/cleaning-service-2.webp",
      imageFallback: "/images/cleaning-service-2.jpg",
      mailSubject: "Anfrage für Fensterreinigung",
    },
    {
      id: "brandschaden",
      kicker: "Notfall",
      title: "Brandschadenreinigung",
      text: "Nach einem Brand beseitigen wir Ruß und Gerüche zügig und gründlich. Gebäude-Feinreinigung, Inventar- und Textilreinigung mit geeigneter Technik.",
      image: "/images/opt/cleaning-service-3.webp",
      imageFallback: "/images/cleaning-service-3.jpg",
      mailSubject: "Anfrage für Brandschadenreinigung",
      extra: ["Gebäude-Feinreinigung", "Inventarreinigung", "Textilreinigung"],
    },
  ],
};

export const REASONS = [
  {
    title: "Festpreis, der hält",
    text: "Sie bekommen eine klare Summe – ohne Nachträge für Selbstverständlichkeiten. Was wir anbieten, rechnen wir so ab.",
  },
  {
    title: "Kurzfristig vor Ort",
    text: "Kleine Struktur, kurze Wege. Wenn es brennt – im übertragenen oder echten Sinn – rücken wir zügig an.",
  },
  {
    title: "Aus einer Hand",
    text: "Abbruch, Ausbau, Umzug, Fliese, Reinigung. Weniger Schnittstellen, weniger Wartezeit, ein Ansprechpartner.",
  },
  {
    title: "Saubere Baustelle",
    text: "Wir schaffen Räume, keine Chaoszonen. Schutz, Entsorgung und Übergabe gehören zum Auftrag, nicht zur Extra-Liste.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Anfrage",
    text: "Kurz schildern, was ansteht – Foto per Mail reicht oft schon.",
  },
  {
    n: "02",
    title: "Besichtigung",
    text: "Wir sehen uns die Fläche an und klären Ablauf, Schutz und Entsorgung.",
  },
  {
    n: "03",
    title: "Festpreis",
    text: "Sie erhalten ein nachvollziehbares Angebot. Keine Überraschungen hinterher.",
  },
  {
    n: "04",
    title: "Umsetzung",
    text: "Termingerecht, mit Fachpersonal, bis der Raum wieder nutzbar ist.",
  },
];

export const FAQS = [
  {
    q: "In welchen Städten ist CCS Gebäudemanagement tätig?",
    a: "Wir sind in Mülheim an der Ruhr ansässig und arbeiten regelmäßig in Essen, Oberhausen, Duisburg, Bottrop, Ratingen, Bochum, Düsseldorf und der näheren Umgebung.",
  },
  {
    q: "Bieten Sie einen Festpreis?",
    a: "Ja. Nach Besichtigung oder klarer Leistungsbeschreibung erhalten Sie ein Festpreisangebot ohne versteckte Positionen.",
  },
  {
    q: "Können Abbruch, Renovierung und Reinigung kombiniert werden?",
    a: "Ja. Genau darin liegt der Vorteil: Entkernung, Trockenbau, Fliesen, Umzug und Endreinigung können aus einer Hand laufen.",
  },
  {
    q: "Bieten Sie Umzug und Kleintransporte an?",
    a: "Ja. Mit Transporter und Fahrer übernehmen wir Umzüge, Möbeltransporte, IKEA- und Möbelhaus-Abholungen sowie die Lieferung von Sofas, Schränken, Betten und Haushaltsgeräten – nah und fern, auch kurzfristig nach Absprache.",
  },
  {
    q: "Wie schnell können Sie starten?",
    a: "Durch unsere Firmenstruktur vergeben wir auch kurzfristige Termine – besonders bei Brandschadenreinigung und dringenden Räumungen.",
  },
];

export const HASH_REDIRECTS = {
  start: "/",
  cleaning: "/reinigung",
  contact: "/kontakt",
  about: "/kontakt",
  imprint: "/impressum",
  abbrucharbeiten: "/leistungen/abbruch",
  demontage: "/leistungen/demontage",
  renovierungen: "/leistungen/renovierung",
  trockenbau: "/leistungen/trockenbau",
  fliesenarbeiten: "/leistungen/fliesen",
  umzug: "/leistungen/umzug",
  kleintransport: "/leistungen/umzug",
  reinigung: "/reinigung",
};
